import Transformation from './transformation';

export default function transform(matrix) {
    if (matrix === null) {
        return null;
    }

    if (matrix instanceof Transformation) {
        return matrix;
    }

    return new Transformation(matrix);
}


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-drawing/dist/es/geometry/transform.js
// module id = ../../../../@progress/kendo-drawing/dist/es/geometry/transform.js
// module chunks = vendor